import { type CSSProperties } from 'react';

import { icons } from '@assets/icons';
import { classesBuilder } from '@common/helpers';

import type { IIconProps } from './types';

import style from './styles.module.scss';

const Icon = ({ name, size = 24, className, style: customStyle, ...props }: IIconProps) => {
  const SvgIcon = icons[name];

  if (!SvgIcon) {
    return null;
  }

  return (
    <SvgIcon
      width={size}
      height={size}
      style={
        {
          '--icon-size': typeof size === 'number' ? `${size}px` : size,
          ...customStyle,
        } as CSSProperties
      }
      {...props}
      className={classesBuilder(style.icon, className)}
    />
  );
};

export default Icon;
